"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const GridConstants_1 = tslib_1.__importDefault(require("./GridConstants"));
class SingleRowGridSelectionState {
    constructor(grid) {
        this.grid = grid;
        this.grid.addClickHandler((event) => {
            this.rowClicked(event);
            event.preventDefault();
        });
        this.grid.addGridChangedListener(this);
    }
    clearSelected() {
        if (this.selectedRow != null) {
            this.deselect(this.selectedRow);
        }
    }
    isSelected(row) {
        const tr = this.grid.getElement(row);
        return this.selectedRow === tr;
    }
    getSelected() {
        if (this.selectedRow == null) {
            return -1;
        }
        return this.getRowForTR(this.selectedRow);
    }
    setSelected(row, select) {
        const tr = this.grid.getElement(row);
        if (select) {
            this.select(tr);
        }
        else {
            this.deselect(tr);
        }
    }
    gridChanged() {
        this.selectedRow = null;
        if (this.selectedData != null) {
            // Element[] elements = grid.dataToRowElementMap.get(selectedData);
            // if (elements != null && elements.length > 0) {
            //  int row = getRowForTR(elements[0]);
            // setSelected(row, true);
            // }
        }
    }
    rowClicked(event) {
        const cell = this.grid.getElementForEvent(event);
        if (cell != null) {
            const tr = cell.parentElement;
            this.clearSelected();
            this.select(tr);
        }
    }
    select(tr) {
        this.selectedRow = this.grid.getRelatedElements(tr);
        this.selectedData = this.grid.getDataForTableRow(tr);
        this.selectedRow?.classList.add(GridConstants_1.default.GRID_ROW_SELECTED);
    }
    deselect(tr) {
        const selectedTR = this.grid.getRelatedElements(tr);
        selectedTR?.classList.remove(GridConstants_1.default.GRID_ROW_SELECTED);
        this.selectedRow = null;
        this.selectedData = null;
    }
    getRowForTR(tr) {
        const body = tr.parentElement;
        for (let i = 0; i < body.children.length; i++) {
            const row = body.children.item(i);
            if (row === tr) {
                return i;
            }
        }
        return -1;
    }
}
exports.default = SingleRowGridSelectionState;
//# sourceMappingURL=SingleRowGridSelectionState.js.map